import type { AnalyticsEvent } from '@atlassian/jira-product-analytics-bridge';
import { getAnalyticsWebClientPromise } from '@atlassian/jira-product-analytics-web-client-async';
import { getGlobalAP } from '../../../../common';
import type { ACJSHost } from '../../../../types';

type AnalyticsEventType = 'operational' | 'page' | 'screen';

export const registerIframeHandlers = (connectHost: ACJSHost) => {
	getGlobalAP()._addonAttemptCounter = {};
	connectHost.setExtensionConfigurationOptions('crev', window._AP.allJsVersion);
	connectHost.onIframeEstablished((data) => {
		data.$el.closest('.ap-iframe-container').addClass('iframe-init');
	});

	// Closes dropdowns when a connect iframe gains focus.
	connectHost.onFrameClick((frame) => {
		frame.click();
	});
};

export const registerAnalyticsHandler = () => {
	window.define('ac/analytics', () => ({
		emitGasV3: <T extends AnalyticsEventType>(eventType: T, event: AnalyticsEvent) => {
			getAnalyticsWebClientPromise().then((client) => {
				const analyticsClient = client.getInstance();

				switch (eventType) {
					case 'operational':
						// @ts-expect-error - Argument of type 'UIAnalyticsEvent' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'.
						analyticsClient.sendOperationalEvent(event);
						break;
					case 'page':
						// @ts-expect-error - Argument of type 'UIAnalyticsEvent' is not assignable to parameter of type 'string'.
						analyticsClient.sendPageEvent(event, undefined);
						break;
					case 'screen':
						// @ts-expect-error - Argument of type 'UIAnalyticsEvent' is not assignable to parameter of type 'SendScreenEventInput'.
						analyticsClient.sendScreenEvent(event);
						break;
					default:
						throw new Error('ACJS: Unknown GasV3 event type');
				}
			});
		},
	}));
};

/**
 * Registers the AMD module `ac/create`. The template `iframe-body-script.vm` in
 * the monolith still uses this bridge when rendering in Jira Dashboards. We can't
 * feature flag the changes in the monolith template because it's used by multiple
 * platforms (like Jira for Android and iOS).
 */
export const registerAcCreate = () => {
	window.define('ac/create', () => ({
		appendConnectAddon: (data: unknown) => getGlobalAP().appendConnectAddon(data),
	}));
};
